module.exports = __webpack_public_path__ + "media/index/target-fb733a51.svg";